/** Figma KSP_Event-page: light 5675:95826, dark 5772:148789/148790. Segments: pmw-bar-blue-*, pmw-bar-orange-*. Middle/track: pmw-bar-track-*. */
export interface SegmentedRatioBarProps {
  /** Home team win probability (0–100). */
  homePercent: number;
  /** Away team win probability (0–100). */
  awayPercent: number;
  /** Optional className for the container. */
  className?: string;
}

/** Draw/other is derived as 100 - homePercent - awayPercent; clamped for bar layout. */
function getDrawPercent(home: number, away: number): number {
  return Math.max(0, 100 - home - away);
}

export default function SegmentedRatioBar({
  homePercent,
  awayPercent,
  className,
}: SegmentedRatioBarProps) {
  const drawPercent = getDrawPercent(homePercent, awayPercent);
  const homeWidth = Math.min(100, homePercent);
  const drawWidth = Math.min(100 - homeWidth, drawPercent);
  const awayWidth = 100 - homeWidth - drawWidth;

  const HOME_BG = 'bg-pmw-bar-blue-light dark:bg-pmw-bar-blue-dark';
  const DRAW_BG = 'bg-pmw-sf-primary-light dark:bg-pmw-bar-track-dark';
  const AWAY_BG = 'bg-pmw-bar-orange-light dark:bg-pmw-bar-orange-dark';

  const segments: { type: 'home' | 'draw' | 'away'; width: number; className: string }[] = [];
  if (homeWidth > 0) segments.push({ type: 'home', width: homeWidth, className: HOME_BG });
  if (drawWidth > 0) segments.push({ type: 'draw', width: drawWidth, className: DRAW_BG });
  if (awayWidth > 0) segments.push({ type: 'away', width: awayWidth, className: AWAY_BG });

  return (
    <div
      className={`flex h-[8px] gap-[2px] w-full max-w-full rounded-[8px] overflow-hidden bg-transparent ${className ?? ''}`}
      role="progressbar"
      aria-valuenow={homePercent + awayPercent}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      {segments.map((seg) => (
        <div
          key={seg.type}
          className={`h-full min-w-0 first:rounded-l-[8px] last:rounded-r-[8px] ${seg.className}`}
          style={{ width: `${seg.width}%` }}
        />
      ))}
    </div>
  );
}
